/**
 * Стартовые отзывы для админки на mock: оценки покупателей до неё без API не
 * доходят. Аптеки и люди выдуманы; уйдёт вместе с этой папкой.
 */
import type { ReviewDto } from '../contract'

const STORES: [number, string][] = [
  [1, 'Аптека №1 · Чиланзар'],
  [2, 'Аптека №2 · Юнусабад'],
  [3, 'Аптека №3 · Мирзо-Улугбек'],
]

const ROWS: [store: number, rating: number, comment: string, name: string][] = [
  [1, 5, 'Собрали заказ за 15 минут, фармацевт всё объяснил.', 'Дилноза'],
  [1, 4, 'Всё хорошо, но пришлось подождать на кассе.', 'Азиз'],
  [2, 2, 'Одного лекарства не оказалось, хотя в приложении было.', 'Малика'],
  [3, 5, '', 'Тимур'],
  [2, 3, 'Долго искали заказ.', 'Нигора'],
  [1, 5, 'Удобно забирать по дороге с работы.', 'Шахзод'],
  [3, 1, 'Аптека была закрыта, хотя по часам должна работать.', 'Ойбек'],
  [2, 4, '', 'Лола'],
  [3, 4, 'Вежливый персонал.', 'Камола'],
  [1, 5, 'Спасибо!', 'Бобур'],
  [2, 5, 'Курьер приехал раньше срока.', 'Гульнора'],
  [3, 3, 'Нормально.', 'Рустам'],
]

export const SEED_REVIEWS: ReviewDto[] = ROWS.map(([store, rating, comment, name], i) => {
  const [storeId, storeName] = STORES[store - 1] as [number, string]
  const day = String(10 - Math.floor(i / 2)).padStart(2, '0')
  return {
    id: i + 1,
    order_id: 1000 + i,
    order_number: 2040 + i,
    store_id: storeId,
    store_name: storeName,
    customer_id: 100 + i,
    customer_name: name,
    customer_phone: `99890${String(1234560 + i)}`,
    rating,
    comment,
    created_at: `2026-10-${day}T${String(9 + (i % 8)).padStart(2, '0')}:00:00.000Z`,
  }
})
